import React from 'react';
import { SvgIconProps } from '@mui/material';
import {
  BarChartIcon,
  CardIcon,
  CumulativeChartIcon,
  LineChartIcon,
  PieChartIcon,
  TableChartIcon,
  TextIcon,
} from '@common/utils/icons/icons';
import { FleetWidgetType } from 'models/enums/fleet-management';

interface CustomWidgetIconProps extends SvgIconProps {
  icon: FleetWidgetType;
}

const CustomWidgetIcon: React.FC<CustomWidgetIconProps> = ({ icon, ...props }) => {
  switch (icon) {
    case FleetWidgetType.BAR_CHART:
      return <BarChartIcon {...props} />;
    case FleetWidgetType.CARD:
      return <CardIcon {...props} />;
    case FleetWidgetType.LINE_CHART:
      return <LineChartIcon {...props} />;
    case FleetWidgetType.CUMULATIVE_CHART:
      return <CumulativeChartIcon {...props} />;
    case FleetWidgetType.PIE_CHART:
      return <PieChartIcon {...props} />;
    case FleetWidgetType.TABLE:
      return <TableChartIcon {...props} />;
    case FleetWidgetType.TEXT:
      return <TextIcon {...props} />;

    default:
      break;
  }

  return null;
};

export default CustomWidgetIcon;
